//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
      appVersionList: [],
        searchRequest: null,
      },

      mutations: {
        updateappVersionList(state, list) {
          state.appVersionList = list;
        },
        updateSearchappVersionListRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async appVersionList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))

          console.log(requestToSend);

            const st = performance.now();
            //const result = await api.post('/api/w/app/list', requestToSend);
            const result = await newAPIPost('/api/w/app/list', requestToSend);
            commit('updateSearchappVersionListRequest', fallbackRequest);
            console.log(JSON.stringify(result));
            return commit('updateappVersionList', result);
            
        },

        saveAppVersion({ dispatch }, request) {
          const requestToSend = JSON.parse(JSON.stringify(request));
          //return api.post('/api/w/app/list', requestToSend)
          return newAPIPost('/api/w/app/list', requestToSend)
        },


      },



      getters: {
        getappVersionList: state => state.appVersionList,
      },
}
